import * as React from "react";
import {
  cn,
} from "@/lib/utils";

// NOTE: AppShell lives in ./app-sidebar (it owns the sidebar + mobile top bar).
// This module only carries the layout primitives.

export function Section({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <section className={cn("flex flex-col gap-6", className)}>{children}</section>;
}

/** The one Card treatment: bg-card, 1px border, var(--radius), p-6. */
export function Panel({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return (
    <div className={cn("rounded-[var(--radius)] border bg-card p-6", className)}>
      {children}
    </div>
  );
}

export function Eyebrow({ children }: { children: React.ReactNode }) {
  return (
    <p className="text-[11px] font-semibold uppercase tracking-[0.1em] text-muted-foreground">
      {children}
    </p>
  );
}

// EmptyState is defined once, in components/state/empty-states.
export { EmptyState } from "@/components/state/empty-states";
